function setupCounter(id, maxlen) {
  const input = document.querySelector('#' + id);
  const label = document.querySelector('label[for="' + id + '"]');
  if (!input || !label) return;

  input.addEventListener('input', (e)=>{
    if (typeof maxlen === "number" && maxlen > 0 && e.target.value.length > maxlen) {
      e.target.value = e.target.value.slice(0, maxlen);
    }

    let span = label.querySelector("span");
    if(!span){
      span = document.createElement("span");
      span.style.marginLeft = '10px';
      label.appendChild(span);
    }
    span.style.display = 'inline';
    span.textContent = e.target.value.length + ' | ' + maxlen;

    if(e.target.value.length === 0){
      span.style.display = 'none';
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
setupCounter("name-tour", 30);
  setupCounter("laenge-strecke", 10);
  setupCounter("elevation-gain", 10);
  setupCounter("performance-metric", 10);
  setupCounter("location", 35);
  setupCounter("date-str", 35);

  const BACKEND_URL = 'https://routa-w3x7.onrender.com';

  const loadingOverlay = document.getElementById('poster-render-loading-overlay');
  const loadingTitle = document.getElementById('poster-render-loading-title');
  const loadingSubtitle = document.getElementById('poster-render-loading-subtitle');

  let loadingMessageTimer = null;
  const loadingMessages = [
    {
      title: "Wir fahren gerade deine Route ab",
      subtitle: "Höhenmeter werden gezählt, Kurven geprüft und dein Poster wird in Form gebracht."
    },
    {
      title: "Wir zählen die Höhenmeter doppelt nach",
      subtitle: "Nur damit aus deinem Berg nicht versehentlich ein kleiner Hügel wird."
    },
    {
      title: "Wir bügeln noch schnell die Kurven glatt",
      subtitle: "Die Vorschau ist gleich im Ziel."
    },
    {
      title: "Der Zielsprint läuft",
      subtitle: "Linien, Texte und Layout werden gerade für deine Vorschau zusammengesetzt."
    }
  ];

  function getCurrentSportType() {
    return (document.getElementById('sport-type')?.value || 'ride').trim().toLowerCase();
  }

  function updateLoadingSportFigure() {
    setLoadingFigureSport(getCurrentSportType());
  }

  function stopLoadingMessages() {
    if (loadingMessageTimer) {
      clearInterval(loadingMessageTimer);
      loadingMessageTimer = null;
    }
  }

  function startLoadingMessages(initialTitle, initialSubtitle) {
    stopLoadingMessages();

    let index = 0;
    if (loadingTitle && initialTitle) loadingTitle.textContent = initialTitle;
    if (loadingSubtitle && initialSubtitle) loadingSubtitle.textContent = initialSubtitle;

    loadingMessageTimer = window.setInterval(() => {
      index = (index + 1) % loadingMessages.length;
      const nextMessage = loadingMessages[index];
      if (loadingTitle) loadingTitle.textContent = nextMessage.title;
      if (loadingSubtitle) loadingSubtitle.textContent = nextMessage.subtitle;
    }, 2200);
  }

  function setLoading(isLoading, titleText, subtitleText) {
    if (!loadingOverlay) return;

    if (isLoading) {
      updateLoadingSportFigure();
      loadingOverlay.classList.add('is-visible');
      loadingOverlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('routa-is-rendering');
      startLoadingMessages(titleText, subtitleText);
    } else {
      loadingOverlay.classList.remove('is-visible');
      loadingOverlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('routa-is-rendering');
      stopLoadingMessages();
    }
  }

  function setLoadingFigureSport(sport) {
    if (!loadingOverlay) return;
    const normalized = String(sport || '').trim().toLowerCase();
    const allowed = ['ride', 'run', 'hike', 'walk'];
    loadingOverlay.setAttribute('data-sport', allowed.includes(normalized) ? normalized : 'ride');
  }

  window.ROUTA_showPosterRenderLoading = function (opts) {
    const o = opts || {};
    setLoadingFigureSport(o.sport || 'ride');
    setLoading(
      true,
      o.title || 'Route wird importiert',
      o.subtitle || 'Das kann einige Zeit dauern. Bitte das Fenster geöffnet lassen.'
    );
  };

  window.ROUTA_hidePosterRenderLoading = function () {
    setLoading(false);
  };

  window.ROUTA_setPosterRenderLoadingSport = function (sport) {
    setLoadingFigureSport(sport);
  };

  const overlay = document.getElementById("poster-modal-overlay");
  if (overlay && overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }

  if (loadingOverlay && loadingOverlay.parentElement !== document.body) {
    document.body.appendChild(loadingOverlay);
  }

  const modalAddToCartBtn = document.getElementById("poster-modal-add-to-cart");
  const themeAddToCartBtn = document.querySelector(".product-form__submit");

  const previewLoadingEl = document.getElementById("poster-preview-loading");
  const savePreviewBtn = document.getElementById("poster-modal-save-preview");
  const previewBtnLabel = document.getElementById("poster-preview-btn-label");
  const ctaNote = document.getElementById("poster-modal-cta-note");
  const actionsEl = document.getElementById("poster-modal-actions");
  const previewPanel = document.getElementById("poster-preview-panel");
  const previewBadge = document.getElementById("poster-preview-badge");
  const sportTypeEl = document.getElementById("sport-type");
  const previewViewSwitch = document.getElementById("poster-preview-view-switch");
  const preview3DWrap = document.getElementById("poster-preview-3d");
  const preview3DCanvas = document.getElementById("poster-preview-3d-canvas");
  const previewImgEl = document.getElementById("poster-preview");
  const previewPlaceholderEl = document.getElementById("poster-preview-placeholder");
  const modalRootEl = document.querySelector(".poster-modal");

  const movingTimeEl = document.getElementById("moving-time");
  const movingTimeFieldEl = document.getElementById("moving-time-field");
  const movingTimeHoursEl = document.getElementById("moving-time-hours");
  const movingTimeMinutesEl = document.getElementById("moving-time-minutes");
  const movingTimeSecondsEl = document.getElementById("moving-time-seconds");
  const performanceMetricEl = document.getElementById("performance-metric");
  const performanceMetricLabelEl = document.getElementById("performance-metric-label");
  const performanceMetricHelperEl = document.getElementById("performance-metric-helper");
  const averageSpeedPropEl = document.getElementById("average-speed-prop");
  const pacePropEl = document.getElementById("pace-prop");
  const performanceMetricTypePropEl = document.getElementById("performance-metric-type-prop");
  const detailsWarningEl = document.getElementById("details-modal-warning");
  const formPageEl = document.getElementById("poster-modal-page-form");
  const previewPageEl = document.getElementById("poster-modal-page-preview");
  const editInputsBtn = document.getElementById("poster-modal-edit-inputs");
  const designSwitcherEl = document.getElementById("poster-design-switcher");
  const designSwitcherListEl = document.getElementById("poster-design-switcher-list");
  const designSwitcherStatusEl = document.getElementById("poster-design-switcher-status");
  const printColorSwitcherEl = document.getElementById("poster-print-color-switcher");
  const printColorSwitcherListEl = document.getElementById("poster-print-color-switcher-list");
  const printColorSwitcherStatusEl = document.getElementById("poster-print-color-switcher-status");
  const prefetchStatusEl = document.getElementById("poster-prefetch-status");
  const posterStylePropertyEl = document.getElementById("routa-poster-style");
  const mapDesignPropertyEl = document.getElementById("routa-map-design");
  const designDisplayPropertyEl = document.getElementById("routa-design-display");
  const printColorPropertyEl = document.getElementById("routa-print-color");
  const printColorDisplayPropertyEl = document.getElementById("routa-print-color-display");

  const DEFAULT_DESIGN_CATALOG = [
    { key: "black_white", label: "Black & White", thumbnail_text: "BW" },
    { key: "color", label: "Color", thumbnail_text: "CO" }
  ];

  const PRINT_COLOR_OPTIONS = [
    { key: "rot", value: "Rot", label: "Rot", hex: "#d40000" },
    { key: "schwarz", value: "Schwarz", label: "Schwarz", hex: "#000000" },
    { key: "gruen", value: "Grün", label: "Grün", hex: "#118a3d" },
    { key: "blau", value: "Blau", label: "Blau", hex: "#0057d8" }
  ];

  const printColorState = {
    currentKey: "rot"
  };

  const designState = {
    availableDesigns: [],
    currentDesignKey: String(window.ROUTA_MAP_DESIGN_KEY || window.ROUTA_MAP_DESIGN || window.ROUTA_DESIGN_KEY || "black_white"),
    previewCache: {},
    previewSignature: "",
    previewDirty: false,
    prewarmAssetKey: "",
    backgroundPreviewWarmupToken: 0,
    previewPromises: {},
    previewWarmupSignature: "",
    activeDesignSelectionToken: 0,
    geometryCacheKey: "",
    geometryPayload: null
  };

  const PACE_SPORT_TYPES = new Set([
    "run",
    "trailrun",
    "walk",
    "hike",
    "swim",
    "virtualrun"
  ]);

  const REQUIRED_FIELD_IDS = [
    "sport-type",
    "name-tour",
    "laenge-strecke",
    "elevation-gain",
    "moving-time",
    "performance-metric",
    "location",
    "date-str"
  ];

  let lastPerformanceMetricMode = null;

  const performanceMetricAutoState = {
    userOverridden: false,
    isAutoFilled: false,
    lastAutoValue: "",
    suppressTracking: false
  };

  function normalizeSportTypeValue(value) {
    return String(value || "").trim().replace(/[\s_-]+/g, "").toLowerCase();
  }

  function isPaceSportType(value) {
    return PACE_SPORT_TYPES.has(normalizeSportTypeValue(value));
  }

  function getCurrentPerformanceMetricMode() {
    return isPaceSportType(sportTypeEl?.value || "") ? "pace" : "speed";
  }

  function normalizeDecimalString(value) {
    return String(value || "").trim().replace(",", ".");
  }

  function stripUnsupportedTitleCharacters(value, options) {
    const raw = String(value || "");
    const opts = options && typeof options === "object" ? options : {};
    const trimEdges = opts.trimEdges !== false;
    let cleaned = raw;

    try {
      cleaned = cleaned
        .replace(/[\p{Extended_Pictographic}\p{Regional_Indicator}\uFE0F\u200D\u20E3]/gu, "");
    } catch (error) {
      cleaned = cleaned.replace(/[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\uFE0F\u200D]/gu, "");
    }

    cleaned = cleaned.replace(/\s{2,}/g, " ");
    return trimEdges ? cleaned.trim() : cleaned;
  }

  function sanitizeRouteTitleInput(options) {
    const titleEl = document.getElementById("name-tour");
    if (!titleEl) return "";
    const cleaned = stripUnsupportedTitleCharacters(titleEl.value || "", options);
    if (titleEl.value !== cleaned) {
      titleEl.value = cleaned;
    }
    return cleaned;
  }

  function isEffectivelyEmptyMetricValue(value, mode) {
    const raw = String(value || "").trim();
    if (!raw) return true;

    if (mode === "pace") {
      const paceSeconds = parsePaceToSeconds(raw);
      return paceSeconds === null || paceSeconds <= 0;
    }

    const speed = parsePositiveNumber(raw);
    return speed === null || speed <= 0;
  }

  function parsePositiveNumber(value) {
    const normalized = normalizeDecimalString(value);
    if (!normalized) return null;
    const parsed = Number(normalized);
    if (!Number.isFinite(parsed) || parsed <= 0) return null;
    return parsed;
  }

  function parseMovingTimeToSeconds(value) {
    const raw = String(value || "").trim();
    if (!raw) return null;
    const parts = raw.split(":");
    if (parts.length !== 2 && parts.length !== 3) return null;
    const nums = parts.map((part) => Number(part));
    if (nums.some((n) => !Number.isFinite(n) || n < 0)) return null;
    if (parts.length === 2) {
      return nums[0] * 3600 + nums[1] * 60;
    }
    return nums[0] * 3600 + nums[1] * 60 + nums[2];
  }

  function parsePaceToSeconds(value) {
    const raw = String(value || "").trim();
    if (!raw) return null;
    const parts = raw.split(":");
    if (parts.length !== 2 && parts.length !== 3) return null;
    const nums = parts.map((part) => Number(part));
    if (nums.some((n) => !Number.isFinite(n) || n < 0)) return null;
    if (parts.length === 2) {
      return nums[0] * 60 + nums[1];
    }
    return nums[0] * 3600 + nums[1] * 60 + nums[2];
  }


  function getMovingTimeSegmentElements() {
    return [movingTimeHoursEl, movingTimeMinutesEl, movingTimeSecondsEl].filter(Boolean);
  }

  function getMovingTimeVisibleInput() {
    return movingTimeHoursEl || movingTimeEl || null;
  }

  function sanitizeTimeSegmentValue(value) {
    return String(value || "").replace(/\D/g, "").slice(0, 2);
  }

  function setMovingTimeSegments(parts) {
    const safeParts = Array.isArray(parts) ? parts : [];
    const [hours = "", minutes = "", seconds = ""] = safeParts;
    if (movingTimeHoursEl) movingTimeHoursEl.value = sanitizeTimeSegmentValue(hours);
    if (movingTimeMinutesEl) movingTimeMinutesEl.value = sanitizeTimeSegmentValue(minutes);
    if (movingTimeSecondsEl) movingTimeSecondsEl.value = sanitizeTimeSegmentValue(seconds);
  }

  function buildCompleteMovingTimeFromSegments() {
    const hours = sanitizeTimeSegmentValue(movingTimeHoursEl?.value);
    const minutes = sanitizeTimeSegmentValue(movingTimeMinutesEl?.value);
    const seconds = sanitizeTimeSegmentValue(movingTimeSecondsEl?.value);

    if (!hours && !minutes && !seconds) return "";
    if (!hours || !minutes || !seconds) return "";

    return hours.padStart(2, "0") + ":" + minutes.padStart(2, "0") + ":" + seconds.padStart(2, "0");
  }

  function syncMovingTimeHiddenFromSegments() {
    if (!movingTimeEl) return "";
    const combined = buildCompleteMovingTimeFromSegments();
    movingTimeEl.value = combined;
    return combined;
  }

  function distributeMovingTimeValue(rawValue) {
    const raw = String(rawValue || "").trim();
    if (!raw) return false;

    let formatted = "";
    const digitOnly = raw.replace(/\D/g, "");

    if (/^\d{6}$/.test(digitOnly) && raw.indexOf(":") === -1) {
      formatted = digitOnly.slice(0, 2) + ":" + digitOnly.slice(2, 4) + ":" + digitOnly.slice(4, 6);
    } else if (/^\d{4}$/.test(digitOnly) && raw.indexOf(":") === -1) {
      formatted = digitOnly.slice(0, 2) + ":" + digitOnly.slice(2, 4) + ":00";
    } else {
      const parsedSeconds = parseMovingTimeToSeconds(raw);
      if (parsedSeconds === null || parsedSeconds <= 0) return false;
      formatted = formatClockValue(parsedSeconds);
    }

    const parts = formatted.split(":");
    if (parts.length !== 3) return false;

    setMovingTimeSegments(parts);
    if (movingTimeEl) movingTimeEl.value = formatted;
    return true;
  }

  function normalizeMovingTimeField() {
    const segmentCombinedValue = buildCompleteMovingTimeFromSegments();
    const raw = segmentCombinedValue || String(movingTimeEl?.value || "").trim();

    if (!raw) {
      if (movingTimeEl) movingTimeEl.value = "";
      return "";
    }

    const seconds = parseMovingTimeToSeconds(raw);
    if (seconds === null || seconds <= 0) {
      return raw;
    }

    const formatted = formatClockValue(seconds);
    setMovingTimeSegments(formatted.split(":"));
    if (movingTimeEl) movingTimeEl.value = formatted;
    return formatted;
  }

  function formatClockValue(totalSeconds) {
    const seconds = Math.max(0, Math.round(Number(totalSeconds) || 0));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(secs).padStart(2, "0");
  }

  function formatPaceValue(totalSeconds) {
    const seconds = Math.max(0, Math.round(Number(totalSeconds) || 0));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0) {
      return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(secs).padStart(2, "0");
    }
    const totalMinutes = Math.floor(seconds / 60);
    return String(totalMinutes).padStart(2, "0") + ":" + String(secs).padStart(2, "0");
  }

  function formatSpeedValue(speed) {
    const normalized = Number(speed);
    if (!Number.isFinite(normalized) || normalized <= 0) return "";
    return normalized.toFixed(1);
  }

  function speedKmhToPaceSeconds(speed) {
    if (!Number.isFinite(speed) || speed <= 0) return null;
    return 3600 / speed;
  }

  function paceSecondsToSpeedKmh(paceSeconds) {
    if (!Number.isFinite(paceSeconds) || paceSeconds <= 0) return null;
    return 3600 / paceSeconds;
  }

  function convertMetricValue(value, fromMode, toMode) {
    const raw = String(value || "").trim();
    if (!raw || fromMode === toMode) return raw;
    if (fromMode === "speed" && toMode === "pace") {
      const speed = parsePositiveNumber(raw);
      return speed ? formatPaceValue(speedKmhToPaceSeconds(speed)) : raw;
    }
    if (fromMode === "pace" && toMode === "speed") {
      const paceSeconds = parsePaceToSeconds(raw);
      return paceSeconds ? formatSpeedValue(paceSecondsToSpeedKmh(paceSeconds)) : raw;
    }
    return raw;
  }

  function normalizePerformanceMetricField() {
    if (!performanceMetricEl) return "";
    const mode = getCurrentPerformanceMetricMode();
    const raw = String(performanceMetricEl.value || "").trim();
    if (!raw) return "";

    if (mode === "pace") {
      const paceSeconds = parsePaceToSeconds(raw);
      if (paceSeconds === null) return raw;
      const formatted = formatPaceValue(paceSeconds);
      if (formatted !== performanceMetricEl.value) performanceMetricEl.value = formatted;
      return formatted;
    }

    const speed = parsePositiveNumber(raw);
    if (speed === null) return raw;
    const formatted = formatSpeedValue(speed);
    if (formatted !== performanceMetricEl.value) performanceMetricEl.value = formatted;
    return formatted;
  }

  function resetPerformanceMetricAutoState() {
    performanceMetricAutoState.userOverridden = false;
    performanceMetricAutoState.isAutoFilled = false;
    performanceMetricAutoState.lastAutoValue = "";
    performanceMetricAutoState.suppressTracking = false;
  }

  function calculateAutomaticPerformanceMetricValue() {
    const distanceKm = parsePositiveNumber(document.getElementById("laenge-strecke")?.value || "");
    const movingTimeSeconds = parseMovingTimeToSeconds(document.getElementById("moving-time")?.value || "");
    if (!distanceKm || !movingTimeSeconds) return "";

    const mode = getCurrentPerformanceMetricMode();
    if (mode === "pace") {
      return formatPaceValue(movingTimeSeconds / distanceKm);
    }

    return formatSpeedValue((distanceKm * 3600) / movingTimeSeconds);
  }

  function shouldAllowAutomaticMetricFill(options) {
    const opts = options || {};
    const mode = getCurrentPerformanceMetricMode();
    const currentValue = String(performanceMetricEl?.value || "").trim();

    if (opts.force) return true;
    if (!performanceMetricAutoState.userOverridden) return true;
    if (performanceMetricAutoState.isAutoFilled && currentValue === performanceMetricAutoState.lastAutoValue) return true;
    if (isEffectivelyEmptyMetricValue(currentValue, mode)) return true;

    return false;
  }

  function applyAutomaticPerformanceMetricValue(options) {
    const opts = options || {};
    if (!performanceMetricEl) return "";

    const autoValue = calculateAutomaticPerformanceMetricValue();
    if (!autoValue) return "";
    if (!shouldAllowAutomaticMetricFill(opts)) return "";

    const currentValue = String(performanceMetricEl.value || "").trim();
    if (currentValue === autoValue) {
      performanceMetricAutoState.lastAutoValue = autoValue;
      performanceMetricAutoState.isAutoFilled = true;
      performanceMetricAutoState.userOverridden = false;
      return autoValue;
    }

    performanceMetricAutoState.suppressTracking = true;
    performanceMetricEl.value = autoValue;
    performanceMetricAutoState.suppressTracking = false;

    performanceMetricAutoState.lastAutoValue = autoValue;
    performanceMetricAutoState.isAutoFilled = true;
    performanceMetricAutoState.userOverridden = false;
    return autoValue;
  }

  function trackPerformanceMetricManualOverride(event) {
    if (!performanceMetricEl || performanceMetricAutoState.suppressTracking) return;

    const raw = String(performanceMetricEl.value || "").trim();
    const mode = getCurrentPerformanceMetricMode();
    const isTrustedUserEvent = !!event?.isTrusted;
    const isFocusedMetricField = document.activeElement === performanceMetricEl;

    if (isEffectivelyEmptyMetricValue(raw, mode)) {
      performanceMetricAutoState.userOverridden = false;
      performanceMetricAutoState.isAutoFilled = false;
      performanceMetricAutoState.lastAutoValue = "";
      return;
    }

    if (performanceMetricAutoState.isAutoFilled && raw === performanceMetricAutoState.lastAutoValue) {
      return;
    }

    if (!isTrustedUserEvent || !isFocusedMetricField) {
      return;
    }

    performanceMetricAutoState.userOverridden = true;
    performanceMetricAutoState.isAutoFilled = false;
  }

  function syncPerformanceMetricProperties() {
    const mode = getCurrentPerformanceMetricMode();
    const raw = String(performanceMetricEl?.value || "").trim();

    if (performanceMetricTypePropEl) performanceMetricTypePropEl.value = mode;

    if (mode === "pace") {
      const paceSeconds = parsePaceToSeconds(raw);
      const paceText = paceSeconds === null ? raw : formatPaceValue(paceSeconds);
      const speed = paceSeconds === null ? null : paceSecondsToSpeedKmh(paceSeconds);

      if (pacePropEl) pacePropEl.value = paceText;
      if (averageSpeedPropEl) averageSpeedPropEl.value = speed ? formatSpeedValue(speed) : "";
      return;
    }

    const speed = parsePositiveNumber(raw);
    if (averageSpeedPropEl) averageSpeedPropEl.value = speed ? formatSpeedValue(speed) : normalizeDecimalString(raw);
    if (pacePropEl) pacePropEl.value = "";
  }

  function updatePerformanceMetricUi(options) {
    const opts = options || {};
    const mode = getCurrentPerformanceMetricMode();

    if (performanceMetricLabelEl) {
      performanceMetricLabelEl.textContent = mode === "pace"
        ? "Pace* (time/km, z. B. 05:00):"
        : "Durchschnittsgeschwindigkeit* (km/h, z. B. 24.3):";
    }

    if (performanceMetricHelperEl) {
      performanceMetricHelperEl.textContent = mode === "pace"
        ? "Für diese Sportart verwenden wir Pace in min/km statt km/h."
        : "Für diese Sportart verwenden wir km/h.";
    }

    const shouldRecalculateAutomatically = !performanceMetricAutoState.userOverridden && (
      performanceMetricAutoState.isAutoFilled ||
      !String(performanceMetricEl?.value || "").trim()
    );

    if (performanceMetricEl) {
      performanceMetricEl.placeholder = mode === "pace" ? "05:00" : "24.3";
      performanceMetricEl.setAttribute("inputmode", mode === "pace" ? "numeric" : "decimal");
      performanceMetricEl.setAttribute("maxlength", mode === "pace" ? "8" : "10");
      performanceMetricEl.dataset.metricMode = mode;

      if (opts.convertCurrentValue !== false && lastPerformanceMetricMode && lastPerformanceMetricMode !== mode && !shouldRecalculateAutomatically) {
        performanceMetricEl.value = convertMetricValue(performanceMetricEl.value, lastPerformanceMetricMode, mode);
      }
    }

    lastPerformanceMetricMode = mode;

    if (shouldRecalculateAutomatically) {
      applyAutomaticPerformanceMetricValue({ force: true });
    }

    normalizePerformanceMetricField();
    syncPerformanceMetricProperties();
  }

  function getFieldValidationState(fieldId) {
    const el = document.getElementById(fieldId);
    const rawValue = fieldId === "moving-time"
      ? String(movingTimeEl?.value || "").trim()
      : String(el?.value || "").trim();
    const state = { missing: false, invalid: false };

    if (!rawValue) {
      state.missing = true;
      return state;
    }

    if (fieldId === "laenge-strecke" || fieldId === "elevation-gain") {
      state.invalid = parsePositiveNumber(rawValue) === null;
      return state;
    }

    if (fieldId === "moving-time") {
      const seconds = parseMovingTimeToSeconds(rawValue);
      state.invalid = seconds === null || seconds <= 0;
      return state;
    }

    if (fieldId === "performance-metric") {
      if (getCurrentPerformanceMetricMode() === "pace") {
        const paceSeconds = parsePaceToSeconds(rawValue);
        state.invalid = paceSeconds === null || paceSeconds <= 0;
      } else {
        state.invalid = parsePositiveNumber(rawValue) === null;
      }
      return state;
    }

    return state;
  }

  function applyFieldValidationState(fieldId, state) {
    const el = document.getElementById(fieldId);
    const label = fieldId === "moving-time"
      ? document.querySelector('label[for="moving-time-hours"]')
      : document.querySelector('label[for="' + fieldId + '"]');
    const fieldWrap = fieldId === "moving-time"
      ? movingTimeFieldEl
      : el?.closest('.field.custom');
    const isMissing = !!state?.missing;
    const isInvalid = !!state?.invalid;

    if (label) {
      label.classList.toggle('is-missing', isMissing);
      label.classList.toggle('is-invalid', isInvalid);
    }

    if (fieldWrap) {
      fieldWrap.classList.toggle('is-missing', isMissing);
      fieldWrap.classList.toggle('is-invalid', isInvalid);
    }

    if (fieldId === "moving-time") {
      getMovingTimeSegmentElements().forEach((segmentEl) => {
        segmentEl.setAttribute('aria-invalid', isMissing || isInvalid ? 'true' : 'false');
      });
    } else if (el) {
      el.setAttribute('aria-invalid', isMissing || isInvalid ? 'true' : 'false');
    }
  }

  function updateRequiredFieldHighlights(options) {
    const opts = options || {};
    let hasIssues = false;
    let firstInvalidEl = null;


    REQUIRED_FIELD_IDS.forEach((fieldId) => {
      const state = getFieldValidationState(fieldId);
      applyFieldValidationState(fieldId, state);
      if ((state.missing || state.invalid) && !firstInvalidEl) {
        firstInvalidEl = fieldId === "moving-time"
          ? getMovingTimeVisibleInput()
          : document.getElementById(fieldId);
      }
      if (state.missing || state.invalid) {
        hasIssues = true;
      }
    });

    if (detailsWarningEl) {
      detailsWarningEl.style.display = hasIssues && opts.revealWarning ? 'block' : 'none';
    }

    if (hasIssues && opts.focusFirstInvalid && firstInvalidEl) {
      firstInvalidEl.focus();
    }

    return !hasIssues;
  }

  const viewer3DState = {
    dispose: null,
    resizeHandler: null,
    requestRefit: null,
    routeMaterial: null,
    activeView: "3d",
    buildToken: 0,
    hasUserInteracted: false
  };

  function setPreviewView() {
    viewer3DState.activeView = "3d";

    if (previewImgEl) previewImgEl.style.display = "none";
    if (preview3DWrap) preview3DWrap.style.display = "block";
    if (previewViewSwitch) previewViewSwitch.style.display = "none";

    if (typeof viewer3DState.requestRefit === "function") {
      requestAnimationFrame(() => {
        viewer3DState.requestRefit();
        requestAnimationFrame(() => {
          viewer3DState.requestRefit();
        });
      });
    }
  }

  if (previewViewSwitch) {
    previewViewSwitch.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-preview-view]");
      if (!btn) return;
      e.preventDefault();
      e.preventDefault();
    });
  }

  function humanizeDesignKey(value) {
    const raw = String(value || '').trim();
    if (!raw) return 'Design';

    const explicit = {
      black_white: 'Black & White',
      color: 'Color'
    };

    const normalized = raw.toLowerCase().replace(/[\s]+/g, '_');
    if (explicit[normalized]) return explicit[normalized];

    return raw
      .split(/[_\s]+/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ') || 'Design';
  }

  function buildFallbackDesignEntry(key) {
    const safeKey = String(key || '').trim();
    const label = humanizeDesignKey(safeKey);
    const thumbnailText = label.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase() || safeKey.slice(0, 2).toUpperCase() || 'DE';
    return {
      key: safeKey,
      label,
      thumbnail_text: thumbnailText
    };
  }

  function getFallbackDesignCatalog() {
    const items = DEFAULT_DESIGN_CATALOG.map((item) => ({ ...item }));
    const currentKey = String(window.ROUTA_MAP_DESIGN_KEY || window.ROUTA_MAP_DESIGN || window.ROUTA_DESIGN_KEY || designState.currentDesignKey || '').trim();

    if (currentKey && !items.some((item) => item && item.key === currentKey)) {
      items.push(buildFallbackDesignEntry(currentKey));
    }

    return items;
  }

  function getDesignThumbnailUrl(designKey) {
    const rawKey = String(designKey || '').trim();
    if (!rawKey) return '';

    const template = String(window.ROUTA_DESIGN_THUMB_URL_TEMPLATE || '').trim();
    if (!template || template.indexOf('__ROUTA_DESIGN_KEY__') === -1) return '';

    return template.replace('__ROUTA_DESIGN_KEY__', encodeURIComponent(rawKey));
  }

  function getDesignThumbnailMarkup(design) {
    const label = String(design?.label || design?.key || 'Design');
    const thumbText = String(design?.thumbnail_text || label || '').slice(0, 2).toUpperCase();
    const thumbUrl = getDesignThumbnailUrl(design?.key || '');

    if (!thumbUrl) {
      return '<span class="poster-design-switcher-thumb">' + thumbText + '</span>';
    }

    return '' +
      '<span class="poster-design-switcher-thumb">' +
        '<img class="poster-design-switcher-thumb-img" src="' + thumbUrl + '" alt="' + label.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') + '" loading="lazy" />' +
        '<span class="poster-design-switcher-thumb-fallback">' + thumbText + '</span>' +
      '</span>';
  }

  function getCurrentDesignLabel() {
    const currentKey = String(designState.currentDesignKey || window.ROUTA_MAP_DESIGN_KEY || window.ROUTA_MAP_DESIGN || window.ROUTA_DESIGN_KEY || "black_white").trim();
    if (!currentKey) return "";

    const match = (designState.availableDesigns || []).find((item) => String(item?.key || "").trim() === currentKey);
    const label = String(match?.label || "").trim();
    return label || humanizeDesignKey(currentKey);
  }

  function syncDesignProperty() {
    const currentKey = String(designState.currentDesignKey || "black_white").trim() || "black_white";
    if (posterStylePropertyEl) {
      posterStylePropertyEl.value = String(window.ROUTA_POSTER_STYLE_KEY || posterStylePropertyEl.value || "top_text").trim() || "top_text";
    }
    const posterStyleDisplayEl = document.getElementById("routa-poster-style-display");
    if (posterStyleDisplayEl) {
      posterStyleDisplayEl.value = String(window.ROUTA_POSTER_STYLE_KEY || posterStylePropertyEl?.value || posterStyleDisplayEl.value || "top_text").trim() || "top_text";
    }
    if (mapDesignPropertyEl) mapDesignPropertyEl.value = currentKey;
    if (designDisplayPropertyEl) designDisplayPropertyEl.value = getCurrentDesignLabel();
    window.ROUTA_MAP_DESIGN_KEY = currentKey;
    window.ROUTA_MAP_DESIGN = currentKey;
    window.ROUTA_DESIGN_KEY = currentKey;
  }

  function getCurrentGpxId() {
    return String(document.getElementById("gpx-id")?.value || "").trim();
  }

  function getLineColorHex() {
    return "#000000";
  }

  function getCurrentFormSnapshot() {
    sanitizeRouteTitleInput({ trimEdges: true });
    normalizeMovingTimeField();
    normalizePerformanceMetricField();
    syncPerformanceMetricProperties();

    return {
      gpx_id: getCurrentGpxId(),
      route_name: document.getElementById("name-tour")?.value || "",
      distance_km: document.getElementById("laenge-strecke")?.value || "",
      elevation_gain: document.getElementById("elevation-gain")?.value || "",
      avg_speed: averageSpeedPropEl?.value || "",
      pace: pacePropEl?.value || "",
      performance_metric_type: performanceMetricTypePropEl?.value || getCurrentPerformanceMetricMode(),
      moving_time: document.getElementById("moving-time")?.value || "",
      location: document.getElementById("location")?.value || "",
      date_str: document.getElementById("date-str")?.value || "",
      sport_type: document.getElementById("sport-type")?.value || "",
      line_color: getLineColorHex()
    };
  }

  function buildSnapshotSignature(snapshot, includeDesign) {
    const src = snapshot || getCurrentFormSnapshot();
    const base = [
      src.gpx_id || "",
      src.route_name || "",
      src.distance_km || "",
      src.elevation_gain || "",
      src.avg_speed || "",
      src.pace || "",
      src.performance_metric_type || "",
      src.moving_time || "",
      src.location || "",
      src.date_str || "",
      src.sport_type || "",
      src.line_color || ""
    ];
    if (includeDesign) base.push(designState.currentDesignKey || "black_white");
    return base.join("||");
  }

  function setPrefetchStatus(message, isBusy) {
    if (!prefetchStatusEl) return;
    const text = String(message || "").trim();
    prefetchStatusEl.textContent = text;
    prefetchStatusEl.style.display = text ? "block" : "none";
    prefetchStatusEl.classList.toggle("is-busy", !!isBusy);
  }

  function setDesignSwitcherStatus(message, isBusy) {
    if (!designSwitcherStatusEl) return;
    designSwitcherStatusEl.textContent = String(message || "").trim();
    designSwitcherStatusEl.classList.toggle("is-busy", !!isBusy);
  }

  function setPrintColorSwitcherStatus(message, isBusy) {
    if (!printColorSwitcherStatusEl) return;
    printColorSwitcherStatusEl.textContent = String(message || "").trim();
    printColorSwitcherStatusEl.classList.toggle("is-busy", !!isBusy);
  }

  function normalizePrintColorKey(value) {
    const normalized = String(value || '').trim().toLowerCase();
    if (!normalized) return '';
    if (normalized.includes('rot') || normalized.includes('red')) return 'rot';
    if (normalized.includes('schwarz') || normalized.includes('black')) return 'schwarz';
    if (normalized.includes('grün') || normalized.includes('gruen') || normalized.includes('green')) return 'gruen';
    if (normalized.includes('blau') || normalized.includes('blue')) return 'blau';
    return '';
  }

  function getPrintColorOptionByKey(key) {
    const normalizedKey = normalizePrintColorKey(key);
    return PRINT_COLOR_OPTIONS.find((item) => item.key === normalizedKey) || null;
  }

  function getSelectedPrintColorOption() {
    return getPrintColorOptionByKey(printColorState.currentKey) || PRINT_COLOR_OPTIONS[0];
  }

  function getSelectedPrintColorHex() {
    const option = getSelectedPrintColorOption();
    return String(option?.hex || '#000000');
  }

  function applySelectedPrintColorToViewer() {
    if (!viewer3DState.routeMaterial || !viewer3DState.routeMaterial.color) return;
    viewer3DState.routeMaterial.color.set(getSelectedPrintColorHex());
    viewer3DState.routeMaterial.needsUpdate = true;
  }

  function renderPrintColorButtons() {
    if (!printColorSwitcherListEl) return;

    if (printColorSwitcherEl) {
      printColorSwitcherEl.style.display = PRINT_COLOR_OPTIONS.length ? 'block' : 'none';
    }

    printColorSwitcherListEl.innerHTML = '';

    PRINT_COLOR_OPTIONS.forEach((color) => {
      const btn = document.createElement('button');
      const isActive = color.key === printColorState.currentKey;
      btn.type = 'button';
      btn.className = 'poster-print-color-btn' + (isActive ? ' is-active' : '');
      btn.setAttribute('data-print-color-key', color.key);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.innerHTML = '' +
        '<span class="poster-print-color-thumb" data-print-color-key="' + color.key + '"></span>' +
        '<span class="poster-print-color-label">' + String(color.label || color.value || color.key || 'Farbe') + '</span>';
      printColorSwitcherListEl.appendChild(btn);
    });
  }

  function syncPrintColorProperty() {
    const option = getSelectedPrintColorOption();
    const value = option?.value || '';
    if (printColorPropertyEl) printColorPropertyEl.value = value;
    if (printColorDisplayPropertyEl) printColorDisplayPropertyEl.value = value;
    return value;
  }

  function initializePrintColorState() {
    const existingValue = String(printColorPropertyEl?.value || '').trim();
    const variantValue = getSelectedOptionValue('Farbe') || getSelectedOptionValue('Color');
    const initialKey = normalizePrintColorKey(existingValue) || normalizePrintColorKey(variantValue) || PRINT_COLOR_OPTIONS[0].key;
    printColorState.currentKey = initialKey;
    syncPrintColorProperty();
    renderPrintColorButtons();
    setPrintColorSwitcherStatus('3D Vorschau wechselt die Farbe sofort.', false);
  }

  function renderDesignButtons() {
    if (!designSwitcherListEl) return;

    const designs = (designState.availableDesigns && designState.availableDesigns.length)
      ? designState.availableDesigns
      : getFallbackDesignCatalog();

    if (!designs.length) {
      designSwitcherListEl.innerHTML = "";
      if (designSwitcherEl) designSwitcherEl.style.display = "none";
      return;
    }

    designSwitcherListEl.innerHTML = "";
    designs.forEach((design) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "poster-design-switcher-btn" + (design.key === designState.currentDesignKey ? " is-active" : "");
      btn.setAttribute("data-design-key", design.key);
      btn.innerHTML =
        getDesignThumbnailMarkup(design) +
        '<span class="poster-design-switcher-label">' + String(design.label || design.key || "Design") + '</span>';
      const thumbImg = btn.querySelector('.poster-design-switcher-thumb-img');
      if (thumbImg) {
        thumbImg.addEventListener('error', function () {
          btn.classList.add('is-thumb-fallback');
        }, { once: true });

        thumbImg.addEventListener('load', function () {
          btn.classList.remove('is-thumb-fallback');
        }, { once: true });
      } else {
        btn.classList.add('is-thumb-fallback');
      }

      btn.addEventListener("click", function () {
        handleDesignSelection(design.key);
      });
      if (designState.backgroundPreviewWarmupToken && !designState.previewCache[design.key]) {
        btn.classList.add("is-loading");
      }
      designSwitcherListEl.appendChild(btn);
    });

    if (designSwitcherEl) {
      designSwitcherEl.style.display = designs.length ? "block" : "none";
    }
  }

  function updateDesignButtonStates() {
    if (!designSwitcherListEl) return;
    designSwitcherListEl.querySelectorAll(".poster-design-switcher-btn").forEach((btn) => {
      const key = btn.getAttribute("data-design-key") || "";
      btn.classList.toggle("is-active", key === designState.currentDesignKey);
      btn.classList.toggle("is-loading", !!designState.backgroundPreviewWarmupToken && !designState.previewCache[key]);
    });
  }

  async function loadDesignCatalog() {
    try {
      const res = await fetch(BACKEND_URL + "/api/poster-designs", { method: "GET" });
      if (!res.ok) throw new Error("design catalog failed");
      const data = await res.json();
      const items = Array.isArray(data?.map_styles) ? data.map_styles : (Array.isArray(data?.designs) ? data.designs : []);
      designState.availableDesigns = items.length ? items : getFallbackDesignCatalog();
    } catch (err) {
      designState.availableDesigns = getFallbackDesignCatalog();
    }

    if (!designState.availableDesigns.some((item) => item.key === designState.currentDesignKey)) {
      designState.currentDesignKey = designState.availableDesigns[0]?.key || "black_white";
    }

    syncDesignProperty();
    renderDesignButtons();
  }

  function setModalStep(step) {
    const nextStep = step === "preview" ? "preview" : "form";
    if (formPageEl) formPageEl.classList.toggle("is-active", nextStep === "form");
    if (previewPageEl) previewPageEl.classList.toggle("is-active", nextStep === "preview");
    if (actionsEl) actionsEl.setAttribute("data-step", nextStep);
    if (modalRootEl) modalRootEl.classList.toggle("is-preview-step", nextStep === "preview");
    if (nextStep === "preview" && typeof viewer3DState.requestRefit === "function") {
      requestAnimationFrame(() => {
        viewer3DState.requestRefit();
        requestAnimationFrame(() => viewer3DState.requestRefit());
      });
    }
  }

  function markPreviewDirty() {
    if (!designState.previewSignature) return;
    designState.previewDirty = true;
    designState.previewCache = {};
    designState.previewPromises = {};
    designState.previewWarmupSignature = "";
    designState.activeDesignSelectionToken = 0;
    designState.previewSignature = "";
    designState.geometryCacheKey = "";
    designState.geometryPayload = null;
    showModalAddToCart(false);
    setPreviewReadyState(false);
    setDesignSwitcherStatus("Vorschau aktualisieren, um die Änderungen zu sehen.", false);
    updateDesignButtonStates();
  }

  function getActivePosterStyleKey() {
    return String(
      window.ROUTA_POSTER_STYLE_KEY ||
      posterStylePropertyEl?.value ||
      "top_text"
    ).trim() || "top_text";
  }

  async function startDesignAssetPrewarm(options) {
    const opts = options || {};
    const gpxId = String(opts.gpxId || getCurrentGpxId() || "").trim();
    if (!gpxId) return;

    await loadDesignCatalog();

    const lineColor = String(opts.lineColor || getLineColorHex() || "").trim();
    const posterStyleKey = String(opts.posterStyleKey || getActivePosterStyleKey() || "top_text").trim() || "top_text";
    const designKeys = designState.availableDesigns.map((item) => item.key).filter(Boolean);
    const prewarmKey = gpxId + "|" + posterStyleKey + "|" + lineColor + "|" + designKeys.join(",");
    if (!opts.force && designState.prewarmAssetKey === prewarmKey) return;
    designState.prewarmAssetKey = prewarmKey;

    setPrefetchStatus("Kartendesigns werden bereits im Hintergrund vorbereitet.", true);

    try {
      const res = await fetch(BACKEND_URL + "/api/prewarm-preview-assets", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          gpx_id: gpxId,
          line_color: lineColor,
          poster_style_key: posterStyleKey,
          design_keys: designKeys
        })
      });
      if (!res.ok) throw new Error("prewarm failed");
      const data = await res.json();
      const warmed = Array.isArray(data?.warmed_design_keys) ? data.warmed_design_keys.length : 0;
      const cached = Array.isArray(data?.cached_design_keys) ? data.cached_design_keys.length : 0;
      const total = warmed + cached;
      setPrefetchStatus(total ? (total + " Kartendesigns vorbereitet.") : "Kartendesigns vorbereitet.", false);
    } catch (err) {
      setPrefetchStatus("Kartendesigns werden geladen, sobald du die Vorschau erzeugst.", false);
    }
  }

  function cachePreviewResult(designKey, snapshotSignature, previewImageUrl) {
    const key = String(designKey || "").trim();
    if (!key || !previewImageUrl) return;

    designState.previewCache[key] = {
      previewImageUrl: previewImageUrl,
      signature: snapshotSignature
    };

    if (designState.previewPromises && designState.previewPromises[key]) {
      delete designState.previewPromises[key];
    }

    updateDesignButtonStates();
  }

  function getCachedPreviewResult(designKey, snapshotSignature) {
    const entry = designState.previewCache[designKey];
    if (!entry) return null;
    if (entry.signature !== snapshotSignature) return null;
    return entry;
  }

  function delay(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, Math.max(0, Number(ms) || 0)));
  }

  async function preloadImage(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = function () { resolve(true); };
      img.onerror = function () { resolve(false); };
      img.src = url;
    });
  }

  async function requestPosterPreview(snapshot, designKey) {
    const formData = buildPosterFormData({ snapshot: snapshot, designKey: designKey });
    if (!formData) return null;

    const res = await fetch(BACKEND_URL + "/api/render-poster", {
      method: "POST",
      body: formData
    });

    if (!res.ok) {
      const raw = await res.text();
      throw new Error("Render-Fehler Status: " + res.status + " " + raw);
    }

    const data = await res.json();
    if (!data.preview_url) return null;

    const previewImageUrl = BACKEND_URL + data.preview_url + "?t=" + Date.now();
    const ok = await preloadImage(previewImageUrl);
    if (!ok) return null;

    return {
      formData: formData,
      previewImageUrl: previewImageUrl
    };
  }

  function getPreviewPromise(designKey, snapshot, snapshotSignature) {
    const key = String(designKey || "").trim();
    if (!key) return Promise.resolve(null);

    const cached = getCachedPreviewResult(key, snapshotSignature);
    if (cached) {
      return Promise.resolve({
        formData: buildPosterFormData({ snapshot: snapshot, designKey: key }),
        previewImageUrl: cached.previewImageUrl
      });
    }

    if (!designState.previewPromises) designState.previewPromises = {};
    const existing = designState.previewPromises[key];
    if (existing && existing.signature === snapshotSignature && existing.promise) {
      return existing.promise;
    }

    const promise = requestPosterPreview(snapshot, key)
      .then((result) => {
        if (result && result.previewImageUrl) {
          cachePreviewResult(key, snapshotSignature, result.previewImageUrl);
        }
        return result;
      })
      .catch((err) => {
        if (designState.previewPromises && designState.previewPromises[key]) {
          delete designState.previewPromises[key];
        }
        throw err;
      });

    designState.previewPromises[key] = {
      signature: snapshotSignature,
      promise: promise
    };

    updateDesignButtonStates();
    return promise;
  }

  async function warmAlternateDesignPreviews(snapshot, sourceDesignKey) {
    const snapshotSignature = buildSnapshotSignature(snapshot, false);
    const warmupToken = Date.now();
    designState.backgroundPreviewWarmupToken = warmupToken;
    designState.previewWarmupSignature = snapshotSignature;
    updateDesignButtonStates();

    const targets = designState.availableDesigns
      .map((item) => item.key)
      .filter((key) => key && key !== sourceDesignKey && !getCachedPreviewResult(key, snapshotSignature));

    if (!targets.length) {
      setDesignSwitcherStatus("Tippe auf ein Kartendesign, um sofort zu wechseln.", false);
      designState.backgroundPreviewWarmupToken = 0;
      updateDesignButtonStates();
      return;
    }

    setDesignSwitcherStatus("Weitere Designs werden im Hintergrund vorbereitet.", true);

    // Wichtig: Nicht alle Poster-Previews parallel rendern.
    // Mehrere gleichzeitige /api/render-poster Requests blockieren Playwright/R2 und machen
    // einen echten Kunden-Klick langsamer. Deshalb wärmen wir nur nacheinander auf und brechen
    // den Warmup ab, sobald der Kunde aktiv ein anderes Design auswählt.
    await delay(350);

    for (const key of targets) {
      if (designState.backgroundPreviewWarmupToken !== warmupToken) break;
      if (designState.currentDesignKey !== sourceDesignKey) break;
      if (designState.previewDirty || designState.previewWarmupSignature !== snapshotSignature) break;
      if (getCachedPreviewResult(key, snapshotSignature)) continue;

      try {
        await getPreviewPromise(key, snapshot, snapshotSignature);
      } catch (err) {
        console.warn("Design preview warmup failed:", key, err);
      }

      await delay(120);
    }

    if (designState.backgroundPreviewWarmupToken === warmupToken) {
      designState.backgroundPreviewWarmupToken = 0;
      setDesignSwitcherStatus("Tippe auf ein Kartendesign, um sofort zu wechseln.", false);
      updateDesignButtonStates();
    }
  }

  async function handleDesignSelection(designKey) {
    if (!designKey || designKey === designState.currentDesignKey) return;

    const selectionToken = Date.now();
    designState.activeDesignSelectionToken = selectionToken;
    designState.backgroundPreviewWarmupToken = 0;
    designState.currentDesignKey = designKey;
    syncDesignProperty();
    updateDesignButtonStates();

    if (!previewPageEl?.classList.contains("is-active")) return;
    if (designState.previewDirty) return;

    const snapshot = getCurrentFormSnapshot();
    const snapshotSignature = buildSnapshotSignature(snapshot, false);
    const cached = getCachedPreviewResult(designKey, snapshotSignature);

    setPreviewLoading(true);
    setDesignSwitcherStatus(cached ? "Kartendesign wird gewechselt." : "Kartendesign wird geladen.", !cached);

    try {
      const result = cached
        ? {
            formData: buildPosterFormData({ snapshot: snapshot, designKey: designKey }),
            previewImageUrl: cached.previewImageUrl
          }
        : await getPreviewPromise(designKey, snapshot, snapshotSignature);

      if (designState.activeDesignSelectionToken !== selectionToken || designState.currentDesignKey !== designKey) {
        return;
      }

      if (result && result.previewImageUrl) {
        await applyPreviewToStage(
          result.previewImageUrl,
          result.formData || buildPosterFormData({ snapshot: snapshot, designKey: designKey }),
          snapshot
        );
        designState.previewDirty = false;
        designState.previewSignature = snapshotSignature;
        setDesignSwitcherStatus("Tippe auf ein Kartendesign, um sofort zu wechseln.", false);
        warmAlternateDesignPreviews(snapshot, designKey);
        return;
      }
    } catch (err) {
      console.warn("Design preview could not be applied from cache or warmup:", err);
    }

    if (designState.activeDesignSelectionToken !== selectionToken || designState.currentDesignKey !== designKey) {
      return;
    }

    await renderPosterFromForm({
      designKey: designKey,
      snapshot: snapshot,
      showGlobalLoading: false,
      localLoadingOnly: true,
      preserveStep: true
    });
  }

  window.ROUTA_startDesignAssetPrewarm = startDesignAssetPrewarm;

  async function loadThreeJsModules() {
    if (!window.__ROUTA_THREE_PROMISE__) {
      window.__ROUTA_THREE_PROMISE__ = Promise.all([
        import("https://esm.sh/three@0.160.0"),
        import("https://esm.sh/three@0.160.0/examples/jsm/controls/OrbitControls.js")
      ]).then(([THREE, Controls]) => ({ THREE, OrbitControls: Controls.OrbitControls }));
    }
    return window.__ROUTA_THREE_PROMISE__;
  }

  function buildPosterFormData(options) {
    const opts = options || {};
    const snapshot = opts.snapshot || getCurrentFormSnapshot();
    const gpxId = String(snapshot.gpx_id || "").trim();
    if (!gpxId) return null;

    const formData = new FormData();
    formData.append("gpx_id", gpxId);
    formData.append("render_quality", "preview");
    formData.append("route_name", snapshot.route_name || "");
    formData.append("distance_km", snapshot.distance_km || "");
    formData.append("elevation_gain", snapshot.elevation_gain || "");
    formData.append("avg_speed", snapshot.avg_speed || "");
    formData.append("pace", snapshot.pace || "");
    formData.append("performance_metric_type", snapshot.performance_metric_type || getCurrentPerformanceMetricMode());
    formData.append("moving_time", snapshot.moving_time || "");
    formData.append("location", snapshot.location || "");
    formData.append("date_str", snapshot.date_str || "");
    formData.append("sport_type", snapshot.sport_type || "");
    formData.append("design", String(opts.designKey || designState.currentDesignKey || window.ROUTA_MAP_DESIGN_KEY || window.ROUTA_MAP_DESIGN || window.ROUTA_DESIGN_KEY || "black_white"));
    formData.append("_map_design", String(opts.designKey || designState.currentDesignKey || window.ROUTA_MAP_DESIGN_KEY || window.ROUTA_MAP_DESIGN || window.ROUTA_DESIGN_KEY || "black_white"));
    formData.append("_design_key", getActivePosterStyleKey());

    const colorName = syncPrintColorProperty();
    formData.append("line_color", "#000000");
    formData.append("_print_color", colorName);
    return formData;
  }

  function destroy3DPreview() {
    if (viewer3DState.resizeHandler) {
      window.removeEventListener("resize", viewer3DState.resizeHandler);
      viewer3DState.resizeHandler = null;
    }
    if (typeof viewer3DState.dispose === "function") {
      viewer3DState.dispose();
    }
    viewer3DState.dispose = null;
    viewer3DState.routeMaterial = null;
    viewer3DState.hasUserInteracted = false;
    if (preview3DCanvas) preview3DCanvas.innerHTML = "";
    if (preview3DWrap) {
      delete preview3DWrap.dataset.ready;
      preview3DWrap.style.display = "none";
    }
    if (previewViewSwitch) previewViewSwitch.style.display = "none";
    setPreviewView();
  }

  async function build3DPreview(previewImageUrl, formData, options) {
    const opts = options || {};
    if (!preview3DCanvas || !preview3DWrap || !formData) return false;

    const buildToken = ++viewer3DState.buildToken;
    destroy3DPreview();

    let payload = opts.payload || null;
    const geometryCacheKey = String(opts.geometryCacheKey || "");

    if (!payload && geometryCacheKey && designState.geometryCacheKey === geometryCacheKey && designState.geometryPayload) {
      payload = designState.geometryPayload;
    }

    if (!payload) {
      const geoRes = await fetch(BACKEND_URL + "/api/poster-3d-preview-data", {
        method: "POST",
        body: formData
      });

      if (!geoRes.ok) {
        throw new Error("3D Preview Fehler Status: " + geoRes.status);
      }

      payload = await geoRes.json();
      if (geometryCacheKey) {
        designState.geometryCacheKey = geometryCacheKey;
        designState.geometryPayload = payload;
      }
    }
    if (buildToken !== viewer3DState.buildToken) return false;
    if (!payload || !Array.isArray(payload.segments) || !payload.segments.length) return false;

    const { THREE, OrbitControls } = await loadThreeJsModules();
    if (buildToken !== viewer3DState.buildToken) return false;

    const previewStageEl = document.getElementById("poster-preview-stage");
    const measuredWidth = Math.max(
      preview3DWrap?.clientWidth || 0,
      preview3DCanvas?.clientWidth || 0,
      Math.round((previewStageEl?.clientHeight || 0) * (21 / 30) * 0.9),
      260
    );
    const measuredHeight = Math.max(
      preview3DWrap?.clientHeight || 0,
      preview3DCanvas?.clientHeight || 0,
      Math.round((previewStageEl?.clientHeight || 0) * 0.9),
      360
    );
    const width = measuredWidth;
    const height = measuredHeight;

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "high-performance" });
    let sourceImageWidth = 0;
    let sourceImageHeight = 0;

    function applyBestRenderResolution(currentWidth, currentHeight) {
      const cssWidth = Math.max(1, Math.round(Number(currentWidth || 1)));
      const cssHeight = Math.max(1, Math.round(Number(currentHeight || 1)));
      const deviceDpr = Math.max(1, Number(window.devicePixelRatio || 1));
      const sourceDprX = sourceImageWidth ? (sourceImageWidth / cssWidth) : 1;
      const sourceDprY = sourceImageHeight ? (sourceImageHeight / cssHeight) : 1;
      const matchedDpr = Math.max(deviceDpr, Math.min(sourceDprX, sourceDprY));
      const dpr = Math.max(1, Math.min(4, matchedDpr));
      renderer.setPixelRatio(dpr);
      renderer.setSize(cssWidth, cssHeight, false);
      renderer.domElement.style.width = cssWidth + "px";
      renderer.domElement.style.height = cssHeight + "px";
      renderer.domElement.style.maxWidth = "100%";
      renderer.domElement.style.maxHeight = "100%";
      renderer.domElement.style.display = "block";
    }

    applyBestRenderResolution(width, height);
    preview3DCanvas.appendChild(renderer.domElement);

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(32, width / height, 0.1, 200);

    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enablePan = true;
    controls.enableDamping = true;
    controls.screenSpacePanning = true;
    controls.minPolarAngle = Math.PI * 0.18;
    controls.maxPolarAngle = Math.PI * 0.5;
    controls.rotateSpeed = 0.9;
    controls.zoomSpeed = 1.05;
    if ("zoomToCursor" in controls) {
      controls.zoomToCursor = true;
    }
    if (THREE.MOUSE) {
      controls.mouseButtons.LEFT = THREE.MOUSE.ROTATE;
      controls.mouseButtons.MIDDLE = THREE.MOUSE.DOLLY;
      controls.mouseButtons.RIGHT = THREE.MOUSE.PAN;
    }
    if (THREE.TOUCH) {
      controls.touches.ONE = THREE.TOUCH.ROTATE;
      controls.touches.TWO = THREE.TOUCH.DOLLY_PAN;
    }

    const ambient = new THREE.AmbientLight(0xffffff, 1.35);
    scene.add(ambient);

    const dirLight = new THREE.DirectionalLight(0xffffff, 1.65);
    dirLight.position.set(18, 20, 22);
    scene.add(dirLight);

    const fillLight = new THREE.DirectionalLight(0xffffff, 0.55);
    fillLight.position.set(-12, -8, 16);
    scene.add(fillLight);

    const posterGroup = new THREE.Group();
    posterGroup.rotation.x = -0.12;
    posterGroup.rotation.y = 0.18;
    scene.add(posterGroup);

    const poster = payload.poster || {};
    const posterWidth = Number(poster.width_units || 21);
    const posterHeight = Number(poster.height_units || 30);
    const routeBaseOffset = Number(payload.route_style?.base_offset || 0.02);
    const routeBaseZ = routeBaseOffset;

    const textureLoader = new THREE.TextureLoader();
    const posterTexture = await new Promise((resolve, reject) => {
      textureLoader.load(previewImageUrl, resolve, undefined, reject);
    });
    if (buildToken !== viewer3DState.buildToken) return false;
    sourceImageWidth = posterTexture.image?.naturalWidth || posterTexture.image?.width || 0;
    sourceImageHeight = posterTexture.image?.naturalHeight || posterTexture.image?.height || 0;
    applyBestRenderResolution(width, height);
    posterTexture.colorSpace = THREE.SRGBColorSpace;
    posterTexture.generateMipmaps = true;
    posterTexture.minFilter = THREE.LinearMipmapLinearFilter;
    posterTexture.magFilter = THREE.LinearFilter;
    posterTexture.anisotropy = Math.max(
      1,
      renderer.capabilities?.getMaxAnisotropy ? renderer.capabilities.getMaxAnisotropy() : 1
    );
    posterTexture.needsUpdate = true;

    const posterFace = new THREE.Mesh(
      new THREE.PlaneGeometry(posterWidth, posterHeight),
      new THREE.MeshBasicMaterial({ map: posterTexture, toneMapped: false })
    );
    posterFace.position.z = 0;
    posterGroup.add(posterFace);

    const routeColor = new THREE.Color(getSelectedPrintColorHex() || (payload.route_style && payload.route_style.line_color) || "#111111");
    const routeMaterial = new THREE.MeshStandardMaterial({
      color: routeColor,
      roughness: 0.4,
      metalness: 0.06
    });
    viewer3DState.routeMaterial = routeMaterial;

    const routeGroup = new THREE.Group();
    posterGroup.add(routeGroup);

    function buildSolidRouteGeometry(segment, baseZ, halfWidth) {
      const cleaned = [];
      for (let i = 0; i < segment.length; i += 1) {
        const p = segment[i];
        const x = Number(p.x || 0);
        const y = Number(p.y || 0);
        const z = Math.max(baseZ + 0.01, Number(p.z || 0));
        if (!cleaned.length) {
          cleaned.push({ x, y, z });
          continue;
        }
        const prev = cleaned[cleaned.length - 1];
        const dx = x - prev.x;
        const dy = y - prev.y;
        const dz = z - prev.z;
        if ((dx * dx) + (dy * dy) + (dz * dz) > 1e-6) {
          cleaned.push({ x, y, z });
        }
      }
      if (cleaned.length < 2) return null;

      const leftTop = [];
      const rightTop = [];
      const leftBottom = [];
      const rightBottom = [];

      for (let i = 0; i < cleaned.length; i += 1) {
        const prev = cleaned[Math.max(0, i - 1)];
        const next = cleaned[Math.min(cleaned.length - 1, i + 1)];
        const tx = next.x - prev.x;
        const ty = next.y - prev.y;
        const len = Math.hypot(tx, ty) || 1;
        const nx = -ty / len;
        const ny = tx / len;
        const p = cleaned[i];
        const lx = p.x + nx * halfWidth;
        const ly = p.y + ny * halfWidth;
        const rx = p.x - nx * halfWidth;
        const ry = p.y - ny * halfWidth;
        leftTop.push(lx, ly, p.z);
        rightTop.push(rx, ry, p.z);
        leftBottom.push(lx, ly, baseZ);
        rightBottom.push(rx, ry, baseZ);
      }

      const positions = [];
      const normals = [];
      const uvs = [];
      const indices = [];
      let vertexOffset = 0;

      function addVertex(x, y, z, nx, ny, nz, u, v) {
        positions.push(x, y, z);
        normals.push(nx, ny, nz);
        uvs.push(u, v);
      }

      function addQuad(a, b, c, d) {
        indices.push(a, b, c, a, c, d);
      }

      function appendStrip(sideA, sideB, normalSign) {
        const count = sideA.length / 3;
        const start = vertexOffset;
        for (let i = 0; i < count; i += 1) {
          const ax = sideA[i * 3];
          const ay = sideA[i * 3 + 1];
          const az = sideA[i * 3 + 2];
          const bx = sideB[i * 3];
          const by = sideB[i * 3 + 1];
          const bz = sideB[i * 3 + 2];
          const tx = bx - ax;
          const ty = by - ay;
          const tz = bz - az;
          const prevIndex = Math.max(0, i - 1);
          const nextIndex = Math.min(count - 1, i + 1);
          const cx = ((sideA[nextIndex * 3] + sideB[nextIndex * 3]) - (sideA[prevIndex * 3] + sideB[prevIndex * 3])) * 0.5;
          const cy = ((sideA[nextIndex * 3 + 1] + sideB[nextIndex * 3 + 1]) - (sideA[prevIndex * 3 + 1] + sideB[prevIndex * 3 + 1])) * 0.5;
          const cz = ((sideA[nextIndex * 3 + 2] + sideB[nextIndex * 3 + 2]) - (sideA[prevIndex * 3 + 2] + sideB[prevIndex * 3 + 2])) * 0.5;
          const normal = new THREE.Vector3(tx, ty, tz).cross(new THREE.Vector3(cx, cy, cz)).normalize().multiplyScalar(normalSign);
          addVertex(ax, ay, az, normal.x, normal.y, normal.z, 0, i / Math.max(count - 1, 1));
          addVertex(bx, by, bz, normal.x, normal.y, normal.z, 1, i / Math.max(count - 1, 1));
        }
        for (let i = 0; i < count - 1; i += 1) {
          const a = start + (i * 2);
          const b = a + 1;
          const c = a + 3;
          const d = a + 2;
          addQuad(a, b, c, d);
        }
        vertexOffset += count * 2;
      }

      appendStrip(leftTop, rightTop, 1);
      appendStrip(rightBottom, leftBottom, 1);
      appendStrip(leftBottom, leftTop, 1);
      appendStrip(rightTop, rightBottom, 1);

      const capPairs = [
        [0, 0, 0, 0],
        [cleaned.length - 1, cleaned.length - 1, cleaned.length - 1, cleaned.length - 1]
      ];
      capPairs.forEach((cap, idx) => {
        const i = idx === 0 ? 0 : cleaned.length - 1;
        const lt = [leftTop[i * 3], leftTop[i * 3 + 1], leftTop[i * 3 + 2]];
        const rt = [rightTop[i * 3], rightTop[i * 3 + 1], rightTop[i * 3 + 2]];
        const lb = [leftBottom[i * 3], leftBottom[i * 3 + 1], leftBottom[i * 3 + 2]];
        const rb = [rightBottom[i * 3], rightBottom[i * 3 + 1], rightBottom[i * 3 + 2]];
        const start = vertexOffset;
        const normal = new THREE.Vector3().subVectors(
          new THREE.Vector3(rt[0], rt[1], rt[2]),
          new THREE.Vector3(lt[0], lt[1], lt[2])
        ).cross(
          new THREE.Vector3().subVectors(
            new THREE.Vector3(lb[0], lb[1], lb[2]),
            new THREE.Vector3(lt[0], lt[1], lt[2])
          )
        ).normalize();
        if (idx === 1) normal.multiplyScalar(-1);
        [lt, rt, rb, lb].forEach((v, j) => addVertex(v[0], v[1], v[2], normal.x, normal.y, normal.z, j === 0 || j === 3 ? 0 : 1, j < 2 ? 1 : 0));
        addQuad(start, start + 1, start + 2, start + 3);
        vertexOffset += 4;
      });

      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
      geometry.setAttribute("normal", new THREE.Float32BufferAttribute(normals, 3));
      geometry.setAttribute("uv", new THREE.Float32BufferAttribute(uvs, 2));
      geometry.setIndex(indices);
      geometry.computeBoundingBox();
      geometry.computeBoundingSphere();
      return geometry;
    }

    const routeHalfWidth = Number(payload.route_style?.solid_half_width || 0.14);
    payload.segments.forEach((segment) => {
      if (!Array.isArray(segment) || segment.length < 2) return;
      const geometry = buildSolidRouteGeometry(segment, routeBaseZ, routeHalfWidth);
      if (!geometry) return;
      const mesh = new THREE.Mesh(geometry, routeMaterial);
      routeGroup.add(mesh);
    });


    let autoSweepActive = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let autoSweepDirection = 1;
    let autoSweepLastTs = 0;
    const autoSweepSpeed = 0.42;
    const focusClampBox = new THREE.Box3();

    function updateFocusClampBox(box, size) {
      focusClampBox.copy(box);
      focusClampBox.expandByVector(new THREE.Vector3(
        Math.max(size.x * 0.035, 0.18),
        Math.max(size.y * 0.035, 0.18),
        Math.max(size.z * 0.6, 0.35)
      ));
    }

    function clampControlsTargetToPoster() {
      if (focusClampBox.isEmpty()) return;
      controls.target.x = THREE.MathUtils.clamp(controls.target.x, focusClampBox.min.x, focusClampBox.max.x);
      controls.target.y = THREE.MathUtils.clamp(controls.target.y, focusClampBox.min.y, focusClampBox.max.y);
      controls.target.z = THREE.MathUtils.clamp(controls.target.z, focusClampBox.min.z, focusClampBox.max.z);
    }

    function setAzimuthAngle(angle) {
      const clampedAngle = THREE.MathUtils.clamp(angle, controls.minAzimuthAngle, controls.maxAzimuthAngle);
      if (typeof controls.setAzimuthalAngle === "function") {
        controls.setAzimuthalAngle(clampedAngle);
        return;
      }

      const offset = camera.position.clone().sub(controls.target);
      const radius = offset.length() || 1;
      const polar = Math.acos(THREE.MathUtils.clamp(offset.y / radius, -1, 1));
      const planarRadius = Math.sin(polar) * radius;
      camera.position.set(
        controls.target.x + planarRadius * Math.sin(clampedAngle),
        controls.target.y + Math.cos(polar) * radius,
        controls.target.z + planarRadius * Math.cos(clampedAngle)
      );
      camera.lookAt(controls.target);
    }

    function stopAutoSweep() {
      autoSweepActive = false;
      viewer3DState.hasUserInteracted = true;
    }

    function fitCameraToObject() {
      const box = new THREE.Box3().setFromObject(posterGroup);
      if (box.isEmpty()) return;
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());
      updateFocusClampBox(box, size);

      const verticalFov = THREE.MathUtils.degToRad(camera.fov);
      const horizontalFov = 2 * Math.atan(Math.tan(verticalFov / 2) * camera.aspect);
      const fitHeightDistance = (size.y * 0.5) / Math.tan(verticalFov / 2);
      const fitWidthDistance = (size.x * 0.5) / Math.tan(horizontalFov / 2);

      const dominantFitDistance = Math.max(fitHeightDistance * 0.98, fitWidthDistance * 0.9);
      const depthAllowance = Math.max(size.z * 1.15, 0.6);
      const framingTightness = 0.9;
      const distance = (dominantFitDistance * framingTightness) + depthAllowance;

      const dir = new THREE.Vector3(0.16, 0.012, 1.10).normalize();
      camera.position.copy(center).add(dir.multiplyScalar(distance));
      camera.near = Math.max(0.05, distance / 160);
      camera.far = Math.max(250, distance * 12);
      camera.updateProjectionMatrix();
      controls.target.copy(center);
      clampControlsTargetToPoster();
      camera.lookAt(controls.target);
      controls.minDistance = Math.max(distance * 0.56, 4);
      controls.maxDistance = distance * 1.18;
      controls.update();

      const azimuthCenter = controls.getAzimuthalAngle();
      const azimuthRange = 0.62;
      controls.minAzimuthAngle = azimuthCenter - azimuthRange;
      controls.maxAzimuthAngle = azimuthCenter + azimuthRange;

      if (!viewer3DState.hasUserInteracted && autoSweepActive) {
        setAzimuthAngle(controls.minAzimuthAngle);
        autoSweepDirection = 1;
      }
      clampControlsTargetToPoster();
      controls.update();
    }

    controls.addEventListener("start", stopAutoSweep);
    renderer.domElement.addEventListener("pointerdown", stopAutoSweep, { passive: true });
    renderer.domElement.addEventListener("touchstart", stopAutoSweep, { passive: true });
    renderer.domElement.addEventListener("wheel", stopAutoSweep, { passive: true });

    fitCameraToObject();

    function renderFrame(ts) {
      const now = typeof ts === "number" ? ts : performance.now();
      const delta = autoSweepLastTs ? Math.min((now - autoSweepLastTs) / 1000, 0.05) : (1 / 60);
      autoSweepLastTs = now;

      if (autoSweepActive && !viewer3DState.hasUserInteracted) {
        const current = controls.getAzimuthalAngle();
        let next = current + (autoSweepDirection * autoSweepSpeed * delta);
        if (next >= controls.maxAzimuthAngle) {
          next = controls.maxAzimuthAngle;
          autoSweepDirection = -1;
        } else if (next <= controls.minAzimuthAngle) {
          next = controls.minAzimuthAngle;
          autoSweepDirection = 1;
        }
        setAzimuthAngle(next);
      }

      clampControlsTargetToPoster();
      controls.update();
      renderer.render(scene, camera);
      viewer3DState.raf = requestAnimationFrame(renderFrame);
    }

    function handleResize() {
      if (!preview3DCanvas || !renderer) return;
      const previewStageEl = document.getElementById("poster-preview-stage");
      const nextW = Math.max(
        preview3DWrap?.clientWidth || 0,
        preview3DCanvas?.clientWidth || 0,
        Math.round((previewStageEl?.clientHeight || 0) * (21 / 30) * 0.9),
        260
      );
      const nextH = Math.max(
        preview3DWrap?.clientHeight || 0,
        preview3DCanvas?.clientHeight || 0,
        Math.round((previewStageEl?.clientHeight || 0) * 0.9),
        360
      );
      camera.aspect = nextW / nextH;
      camera.updateProjectionMatrix();
      applyBestRenderResolution(nextW, nextH);
      fitCameraToObject();
    }

    viewer3DState.requestRefit = handleResize;
    viewer3DState.resizeHandler = handleResize;
    window.addEventListener("resize", handleResize);
    viewer3DState.dispose = function () {
      if (viewer3DState.raf) cancelAnimationFrame(viewer3DState.raf);
      viewer3DState.requestRefit = null;
      controls.removeEventListener("start", stopAutoSweep);
      renderer.domElement.removeEventListener("pointerdown", stopAutoSweep);
      renderer.domElement.removeEventListener("touchstart", stopAutoSweep);
      renderer.domElement.removeEventListener("wheel", stopAutoSweep);
      controls.dispose();
      renderer.dispose();
      posterTexture.dispose();
      posterFace.geometry.dispose();
      posterFace.material.dispose();
      routeGroup.traverse((obj) => {
        if (obj.geometry) obj.geometry.dispose();
        if (obj.material && obj.material.dispose) obj.material.dispose();
      });
      posterGroup.traverse((obj) => {
        if (obj !== posterFace && obj.geometry) obj.geometry.dispose();
      });
      routeMaterial.dispose();
      if (renderer.domElement && renderer.domElement.parentNode) {
        renderer.domElement.parentNode.removeChild(renderer.domElement);
      }
    };

    preview3DWrap.dataset.ready = "true";
    if (previewViewSwitch) previewViewSwitch.style.display = "none";
    preview3DWrap.style.display = "block";
    handleResize();
    setPreviewView();
    renderFrame();
    return true;
  }


  if (sportTypeEl) {
    sportTypeEl.addEventListener("change", function() {
      updateLoadingSportFigure();
      updatePerformanceMetricUi({ convertCurrentValue: true });
      if (designState.previewSignature) {
        markPreviewDirty();
      }
      updateRequiredFieldHighlights();
    });
    updateLoadingSportFigure();
  }

  function setPreviewReadyState(isReady) {
    if (!previewBadge) return;
    if (isReady) {
      previewBadge.textContent = "Vorschau bereit";
      previewBadge.classList.add("is-ready");
    } else {
      previewBadge.textContent = "Noch nicht erstellt";
      previewBadge.classList.remove("is-ready");
    }
  }

  function revealPreview() {
    if (!previewPanel) return;
    requestAnimationFrame(() => {
      previewPanel.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  function setPreviewLoading(isLoading) {
    if (!previewLoadingEl) return;
    if (isLoading) {
      previewLoadingEl.classList.add("is-visible");
      previewLoadingEl.setAttribute("aria-hidden", "false");
    } else {
      previewLoadingEl.classList.remove("is-visible");
      previewLoadingEl.setAttribute("aria-hidden", "true");
    }
  }

  function setPreviewButtonBusy(isBusy) {
    if (!savePreviewBtn) return;

    savePreviewBtn.disabled = isBusy;
    if (isBusy) {
      savePreviewBtn.classList.add("is-busy");
      if (previewBtnLabel) previewBtnLabel.textContent = "Vorschau wird erstellt";
    } else {
      savePreviewBtn.classList.remove("is-busy");
      if (previewBtnLabel) previewBtnLabel.textContent = "Vorschau generieren";
    }
  }

  function showModalAddToCart(show) {
    if (modalAddToCartBtn) {
      if (show) modalAddToCartBtn.classList.add("is-visible");
      else modalAddToCartBtn.classList.remove("is-visible");
    }

    if (ctaNote) {
      ctaNote.style.display = show ? "block" : "none";
    }

    if (actionsEl) {
      if (show) actionsEl.classList.add("cta-ready");
      else actionsEl.classList.remove("cta-ready");
    }
  }

  function getSelectedVariantId() {
    const idInput =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');
    return idInput ? idInput.value : "";
  }

  function getSelectedOptionValue(optionName) {
    const product = window.ROUTA_PRODUCT;
    if (!product || !product.options || !product.variants) return "";

    const idx = product.options.findIndex(o =>
      String(o || "").trim().toLowerCase() === String(optionName || "").trim().toLowerCase()
    );
    if (idx < 0) return "";

    const variantId = getSelectedVariantId();
    const variant = product.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return "";

    const opts = variant.options || [];
    return String(opts[idx] || "").trim();
  }

  function mapColorNameToHex(colorName) {
    const n = String(colorName || "").trim().toLowerCase();

    if (n.includes("rot") || n.includes("red")) return "#d40000";
    if (n.includes("schwarz") || n.includes("black")) return "#000000";
    if (n.includes("grün") || n.includes("gruen") || n.includes("green")) return "#118a3d";
    if (n.includes("blau") || n.includes("blue")) return "#0057d8";

    if (n.startsWith("#") && (n.length === 7 || n.length === 4)) return n;

    return "#000000";
  }

  async function applyPreviewToStage(previewImageUrl, formData, snapshot) {
    const previewImg = document.getElementById("poster-preview");
    const placeholder = document.getElementById("poster-preview-placeholder");
    const geometryCacheKey = buildSnapshotSignature(snapshot || getCurrentFormSnapshot(), false);

    if (previewImg) {
      previewImg.src = previewImageUrl;
      previewImg.style.display = "block";
    }
    if (placeholder) placeholder.style.display = "none";

    try {
      await build3DPreview(previewImageUrl, formData, { geometryCacheKey: geometryCacheKey });
    } catch (threeErr) {
      console.warn("3D Vorschau konnte nicht aufgebaut werden:", threeErr);
      destroy3DPreview();
    }

    setPreviewReadyState(true);
    setPreviewLoading(false);
    setPreviewButtonBusy(false);
    showModalAddToCart(true);
    setPreviewView();
    revealPreview();
  }

  async function renderPosterFromForm(options) {
    const opts = options || {};
    const snapshot = opts.snapshot || getCurrentFormSnapshot();
    const snapshotSignature = buildSnapshotSignature(snapshot, false);
    const designKey = String(opts.designKey || designState.currentDesignKey || "black_white");
    const cached = getCachedPreviewResult(designKey, snapshotSignature);

    designState.currentDesignKey = designKey;
    syncDesignProperty();
    updateDesignButtonStates();

    if (cached) {
      const cachedFormData = buildPosterFormData({ snapshot: snapshot, designKey: designKey });
      if (!cachedFormData) return false;
      destroy3DPreview();
      setPreviewLoading(true);
      try {
        await applyPreviewToStage(cached.previewImageUrl, cachedFormData, snapshot);
        designState.previewDirty = false;
        designState.previewSignature = snapshotSignature;
        setDesignSwitcherStatus("Tippe auf ein Kartendesign, um sofort zu wechseln.", false);
        return true;
      } catch (err) {
        console.warn("Cached preview apply failed:", err);
      }
    }

    const formData = buildPosterFormData({ snapshot: snapshot, designKey: designKey });
    if (!formData) {
      console.warn("Keine gpx_id vorhanden. Kein Preview möglich.");
      return false;
    }

    destroy3DPreview();
    if (!opts.localLoadingOnly) {
      setLoading(true, 'Poster Vorschau wird gerendert', 'Das kann einige Zeit dauern. Bitte das Fenster geöffnet lassen.');
    }
    setPreviewLoading(true);
    setPreviewButtonBusy(true);

    try {
      const result = await getPreviewPromise(designKey, snapshot, snapshotSignature);
      if (!result) throw new Error("Preview image missing");
      await applyPreviewToStage(result.previewImageUrl, result.formData, snapshot);

      if (!opts.localLoadingOnly) {
        setLoading(false);
      }

      designState.previewDirty = false;
      designState.previewSignature = snapshotSignature;
      designState.currentDesignKey = designKey;
      syncDesignProperty();
      setDesignSwitcherStatus("Tippe auf ein Kartendesign, um sofort zu wechseln.", false);

      if (!opts.preserveStep) {
        setModalStep("preview");
      }

      warmAlternateDesignPreviews(snapshot, designKey);
      return true;

    } catch (err) {
      console.error("[PREVIEW] Fehler:", err);
      setPreviewReadyState(false);
      setPreviewLoading(false);
      setPreviewButtonBusy(false);
      if (!opts.localLoadingOnly) {
        setLoading(false);
      }
      setDesignSwitcherStatus("Dieses Design konnte gerade nicht geladen werden.", false);
      return false;
    }
  }


  const closeBtn = document.getElementById("poster-modal-close");
  const closeX = document.getElementById("poster-modal-x");

  const detailsBtn = document.getElementById("button-ride-details");
  const detailsStatus = document.getElementById("ride-details-status");
  const detailsError = document.getElementById("ride-details-error");
  const addToCart = document.querySelector(".product-form__submit");

  function requiredFieldsOk() {
    normalizeMovingTimeField();
    normalizePerformanceMetricField();
    syncPerformanceMetricProperties();
    return updateRequiredFieldHighlights({ focusFirstInvalid: true, revealWarning: true });
  }

  function markDetailsSetUi() {
    if (!detailsBtn) return;

    detailsBtn.dataset.set = "true";
    detailsBtn.textContent = "Details bearbeiten";
    detailsBtn.style.display = "inline-flex";

    if (detailsStatus) {
      detailsStatus.textContent = "Details gespeichert";
      detailsStatus.style.display = "block";
    }

    updateRouteChoiceEmphasis();
    if (typeof window.ROUTA_refreshRouteStepButtons === 'function') {
      window.ROUTA_refreshRouteStepButtons();
    }
  }

  function updateRouteChoiceEmphasis() {
    var gpxIdEl = document.getElementById("gpx-id");
    var detailsBtnEl = document.getElementById("button-ride-details");

    var gpxId = (gpxIdEl && gpxIdEl.value ? gpxIdEl.value : "").trim();
    var detailsSet = !!(detailsBtnEl && detailsBtnEl.dataset && detailsBtnEl.dataset.set === "true");

    var locked = !!gpxId && detailsSet;

    if (!document.body) return;
    if (locked) document.body.classList.add("routa-route-locked");
    else document.body.classList.remove("routa-route-locked");
  }

  window.ROUTA_updateRouteChoiceEmphasis = updateRouteChoiceEmphasis;
  updateRouteChoiceEmphasis();

  if (printColorSwitcherListEl) {
    printColorSwitcherListEl.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-print-color-key]');
      if (!btn) return;
      e.preventDefault();

      const nextKey = normalizePrintColorKey(btn.getAttribute('data-print-color-key'));
      if (!nextKey || nextKey === printColorState.currentKey) return;

      printColorState.currentKey = nextKey;
      syncPrintColorProperty();
      renderPrintColorButtons();
      applySelectedPrintColorToViewer();
      setPrintColorSwitcherStatus('3D Vorschau aktualisiert sich sofort.', false);
    });
  }

  function closeModal() {
    if (overlay) overlay.classList.remove("is-visible");
    updateRouteChoiceEmphasis();
    if (typeof window.ROUTA_refreshRouteStepButtons === 'function') {
      window.ROUTA_refreshRouteStepButtons();
    }
  }

  function openModal() {
    if (!overlay) return;
    overlay.classList.add("is-visible");
    setModalStep((designState.previewSignature && !designState.previewDirty) ? "preview" : "form");
    const modalEl = overlay.querySelector(".poster-modal");
    if (modalEl) modalEl.scrollTop = 0;
    if (typeof window.ROUTA_refreshRouteStepButtons === 'function') {
      window.ROUTA_refreshRouteStepButtons();
    }
  }

  window.ROUTA_openRideDetailsModal = openModal;
  window.ROUTA_closeRideDetailsModal = closeModal;

  if (detailsBtn && overlay) {
    detailsBtn.addEventListener("click", function(e) {
      e.preventDefault();
      if (detailsError) detailsError.style.display = "none";
      openModal();
    });
  }

  if (savePreviewBtn) {
    savePreviewBtn.addEventListener("click", async function(e) {
      e.preventDefault();
      if (!requiredFieldsOk()) return;

      markDetailsSetUi();

      const ok = await renderPosterFromForm({ preserveStep: false });
      if (ok) {
        setModalStep("preview");
      }
    });
  }

  if (editInputsBtn) {
    editInputsBtn.addEventListener("click", function(e) {
      e.preventDefault();
      setModalStep("form");
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function(e) {
      e.preventDefault();
      closeModal();
    });
  }

  if (closeX) {
    closeX.addEventListener("click", function(e) {
      e.preventDefault();
      closeModal();
    });
  }

  if (overlay) {
    overlay.addEventListener("click", function(e) {
      if (e.target === overlay) closeModal();
    });
  }

  if (modalAddToCartBtn) {
    modalAddToCartBtn.addEventListener("click", function(e) {
      e.preventDefault();

      if (!themeAddToCartBtn) {
        console.warn("Theme Add to cart Button nicht gefunden (.product-form__submit).");
        return;
      }

      closeModal();

      setTimeout(() => {
        themeAddToCartBtn.click();
      }, 50);
    });
  }

  function getPreferredDetailsActionTarget() {
    const candidateIds = [
      "button-ride-details",
      "routaGpxImportMultiBtn",
      "routaStravaImportBtn",
      "routaStravaTogglePickerBtn"
    ];

    for (const id of candidateIds) {
      const el = document.getElementById(id);
      if (!el) continue;
      if (el.offsetParent !== null) return el;
    }

    return detailsBtn || null;
  }

  if (addToCart) {
    addToCart.addEventListener("click", function(e) {
      if (!detailsBtn || !detailsBtn.dataset.set || detailsBtn.dataset.set !== "true" || designState.previewDirty || !designState.previewSignature) {
        e.preventDefault();
        if (detailsError) detailsError.style.display = "block";
        const actionTarget = getPreferredDetailsActionTarget();
        if (actionTarget) actionTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      if (detailsError) detailsError.style.display = "none";
      if (detailsBtn) detailsBtn.style.display = "none";
      if (detailsStatus) detailsStatus.style.display = "none";
    });
  }

  function resetAllRideFields() {
    resetPerformanceMetricAutoState();

    const ids = [
      "name-tour",
      "laenge-strecke",
      "elevation-gain",
      "moving-time",
      "performance-metric",
      "location",
      "date-str"
    ];

    ids.forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      el.value = "";
      el.dispatchEvent(new Event("input", { bubbles: true }));
    });

    setMovingTimeSegments(["", "", ""]);
    syncMovingTimeHiddenFromSegments();

    const sport = document.getElementById("sport-type");
    if (sport) {
      sport.value = "";
      sport.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function resetPreviewUi() {
    const previewImg = document.getElementById("poster-preview");
    const placeholder = document.getElementById("poster-preview-placeholder");

    destroy3DPreview();

    if (previewImg) {
      previewImg.src = "";
      previewImg.style.display = "none";
    }
    if (placeholder) {
      placeholder.style.display = "block";
    }

    setPreviewReadyState(false);
  }

  window.ROUTA_resetDesignFlow = function() {
    closeModal();
    setLoading(false, "", "");
    setPreviewLoading(false);
    setPreviewButtonBusy(false);

    const warningBox = document.getElementById("details-modal-warning");
    if (warningBox) warningBox.style.display = "none";

    resetAllRideFields();
    resetPreviewUi();

    designState.previewCache = {};
    designState.previewPromises = {};
    designState.previewWarmupSignature = "";
    designState.previewSignature = "";
    designState.previewDirty = false;
    designState.prewarmAssetKey = "";
    designState.backgroundPreviewWarmupToken = 0;
    designState.geometryCacheKey = "";
    designState.geometryPayload = null;
    designState.currentDesignKey = String(window.ROUTA_MAP_DESIGN_KEY || window.ROUTA_MAP_DESIGN || window.ROUTA_DESIGN_KEY || DEFAULT_DESIGN_CATALOG[0].key || "black_white");
    syncDesignProperty();
    renderDesignButtons();
    setPrefetchStatus("", false);
    setDesignSwitcherStatus("", false);
    setPrintColorSwitcherStatus("3D Vorschau wechselt die Farbe sofort.", false);
    initializePrintColorState();
    setModalStep("form");

    showModalAddToCart(false);

    const gpxId = document.getElementById("gpx-id");
    if (gpxId) gpxId.value = "";

    if (detailsBtn) {
      detailsBtn.dataset.set = "false";
      detailsBtn.textContent = "Details eingeben";
      detailsBtn.style.display = "none";
    }

    if (detailsStatus) {
      detailsStatus.textContent = "Details noch nicht gespeichert";
      detailsStatus.style.display = "none";
    }

    if (detailsError) {
      detailsError.style.display = "none";
    }

    if (document.body) document.body.classList.remove("routa-route-locked");
    if (typeof window.ROUTA_refreshRouteStepButtons === 'function') {
      window.ROUTA_refreshRouteStepButtons();
    }
  };

  function handleRequiredFieldMutation(event) {
    const fieldId = String(event?.target?.id || "");

    if (fieldId === "name-tour") {
      sanitizeRouteTitleInput({ trimEdges: false });
    }

    if (fieldId === "performance-metric") {
      trackPerformanceMetricManualOverride(event);
    }

    if (fieldId === "laenge-strecke" || fieldId === "moving-time" || fieldId === "sport-type") {
      applyAutomaticPerformanceMetricValue({ force: fieldId === "sport-type" });
    }

    syncPerformanceMetricProperties();
    if (designState.previewSignature) {
      markPreviewDirty();
    }
    updateRequiredFieldHighlights();
  }

  [
    "sport-type",
    "name-tour",
    "laenge-strecke",
    "elevation-gain",
    "performance-metric",
    "location",
    "date-str"
  ].forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.addEventListener("input", handleRequiredFieldMutation);
    el.addEventListener("change", handleRequiredFieldMutation);
  });

  const movingTimeSegments = getMovingTimeSegmentElements();
  if (movingTimeSegments.length) {
    const triggerMovingTimeRefresh = function() {
      syncMovingTimeHiddenFromSegments();
      handleRequiredFieldMutation({ target: { id: "moving-time" } });
    };

    const triggerMovingTimeNormalizeAndRefresh = function() {
      normalizeMovingTimeField();
      handleRequiredFieldMutation({ target: { id: "moving-time" } });
    };

    movingTimeSegments.forEach((segmentEl, index) => {
      segmentEl.addEventListener("focus", function() {
        segmentEl.select();
      });

      segmentEl.addEventListener("input", function(event) {
        const rawValue = String(event.target.value || "");

        if (rawValue.indexOf(":") !== -1 && distributeMovingTimeValue(rawValue)) {
          triggerMovingTimeNormalizeAndRefresh();
          if (movingTimeSecondsEl) {
            movingTimeSecondsEl.focus();
            movingTimeSecondsEl.select();
          }
          return;
        }

        const sanitized = sanitizeTimeSegmentValue(rawValue);
        if (sanitized !== rawValue) {
          event.target.value = sanitized;
        }

        triggerMovingTimeRefresh();

        if (sanitized.length === 2 && index < movingTimeSegments.length - 1) {
          const nextEl = movingTimeSegments[index + 1];
          if (nextEl) {
            nextEl.focus();
            nextEl.select();
          }
        }
      });

      segmentEl.addEventListener("keydown", function(event) {
        if (event.key === "Backspace" && !segmentEl.value && index > 0) {
          const prevEl = movingTimeSegments[index - 1];
          if (prevEl) {
            prevEl.focus();
            prevEl.select();
          }
        }

        if (event.key === "ArrowLeft" && index > 0 && segmentEl.selectionStart === 0 && segmentEl.selectionEnd === 0) {
          const prevEl = movingTimeSegments[index - 1];
          if (prevEl) {
            prevEl.focus();
            prevEl.select();
            event.preventDefault();
          }
        }

        if (event.key === "ArrowRight" && index < movingTimeSegments.length - 1 && segmentEl.selectionStart === segmentEl.value.length && segmentEl.selectionEnd === segmentEl.value.length) {
          const nextEl = movingTimeSegments[index + 1];
          if (nextEl) {
            nextEl.focus();
            nextEl.select();
            event.preventDefault();
          }
        }
      });

      segmentEl.addEventListener("paste", function(event) {
        const pastedText = event.clipboardData?.getData("text") || window.clipboardData?.getData("Text") || "";
        if (!pastedText) return;
        if (!distributeMovingTimeValue(pastedText)) return;

        event.preventDefault();
        triggerMovingTimeNormalizeAndRefresh();
        if (movingTimeSecondsEl) {
          movingTimeSecondsEl.focus();
          movingTimeSecondsEl.select();
        }
      });

      segmentEl.addEventListener("blur", function() {
        if (segmentEl.value.length === 1) {
          segmentEl.value = segmentEl.value.padStart(2, "0");
        }
        triggerMovingTimeNormalizeAndRefresh();
      });

      segmentEl.addEventListener("change", triggerMovingTimeNormalizeAndRefresh);
    });

    if (movingTimeEl?.value) {
      normalizeMovingTimeField();
    }
  }

  if (performanceMetricEl) {
    performanceMetricEl.addEventListener("blur", function() {
      normalizePerformanceMetricField();
      syncPerformanceMetricProperties();
      updateRequiredFieldHighlights();
    });
  }

  const distanceEl = document.getElementById("laenge-strecke");
  if (distanceEl) {
    const refreshCalculatedMetricFromDistance = function() {
      applyAutomaticPerformanceMetricValue();
      syncPerformanceMetricProperties();
      updateRequiredFieldHighlights();
    };

    distanceEl.addEventListener("keyup", refreshCalculatedMetricFromDistance);
    distanceEl.addEventListener("paste", function() {
      window.setTimeout(refreshCalculatedMetricFromDistance, 0);
    });
  }

  const routeTitleEl = document.getElementById("name-tour");
  if (routeTitleEl) {
    routeTitleEl.addEventListener("blur", function() {
      sanitizeRouteTitleInput({ trimEdges: true });
    });
    routeTitleEl.addEventListener("paste", function() {
      window.setTimeout(function() {
        sanitizeRouteTitleInput({ trimEdges: false });
        if (designState.previewSignature) {
          markPreviewDirty();
        }
        updateRequiredFieldHighlights();
      }, 0);
    });
  }

  window.ROUTA_refreshRideDetailsFields = function() {
    sanitizeRouteTitleInput({ trimEdges: true });
    updatePerformanceMetricUi({ convertCurrentValue: false });
    normalizeMovingTimeField();
    applyAutomaticPerformanceMetricValue();
    syncPerformanceMetricProperties();
    updateRequiredFieldHighlights();
  };

  window.addEventListener("routa:gpx-imported", function(event) {
    const detail = event && event.detail ? event.detail : {};
    if (detail.gpxId) {
      const gpxIdEl = document.getElementById("gpx-id");
      if (gpxIdEl && !gpxIdEl.value) gpxIdEl.value = detail.gpxId;
    }
    startDesignAssetPrewarm({ gpxId: detail.gpxId || getCurrentGpxId(), force: true });
    if (typeof window.ROUTA_refreshRouteStepButtons === 'function') {
      window.ROUTA_refreshRouteStepButtons();
    }
  });

  initializePrintColorState();
  sanitizeRouteTitleInput({ trimEdges: true });
  updatePerformanceMetricUi({ convertCurrentValue: false });
  normalizeMovingTimeField();
  applyAutomaticPerformanceMetricValue();
  syncPerformanceMetricProperties();
  updateRequiredFieldHighlights();

  loadDesignCatalog();
  setModalStep("form");
  showModalAddToCart(false);
  setPreviewLoading(false);
  setPreviewButtonBusy(false);
  setPreviewReadyState(false);
  setPreviewView();
});

